import { useCallback, useEffect, useState } from "react";
import api from "../../lib/api";

export const fmtR = (n) => {
  const v = Number(n || 0);
  const s = Math.abs(v).toLocaleString("en-ZA", { maximumFractionDigits: 0 }).replace(/,/g, " ");
  return `${v < 0 ? "−" : ""}R ${s}`;
};

export const isScorecardEditor = (u) => ["owner", "admin", "manager"].includes(u?.role);

export function useScorecard({ projectId, includeClosed = false, poll = true } = {}) {
  const [data, setData] = useState({ projects: [], can_edit: false });
  const [loading, setLoading] = useState(true);
  const load = useCallback(async () => {
    try {
      const { data: d } = await api.get("/scorecard", {
        params: { project_id: projectId || undefined, include_closed: includeClosed || undefined },
      });
      setData(d);
    } catch {
      // Banner must never break the page — retry once shortly (e.g. right after login).
      setTimeout(() => api.get("/scorecard", { params: { project_id: projectId || undefined, include_closed: includeClosed || undefined } })
        .then(({ data: d }) => setData(d)).catch(() => {}), 3000);
    } finally {
      setLoading(false);
    }
  }, [projectId, includeClosed]);
  useEffect(() => {
    load();
    if (!poll) return undefined;
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, [load, poll]);
  return { ...data, loading, reload: load };
}
